module.exports = "/images/inventory_black.svg?d5fd183afe57bbfcfc65a088545aaba2";